export { default as CubeIcon } from './CubeIcon';
